import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import IntegrationActions, { integrationActionTypes } from '../../actions/integrations/integrationsActions';
import IntegrationServices from '../../services/integrations/integrationServices';

/**
 * @param action
 */
function* _getIntegrations(action) {
  try {
    const {
      orgId, callback,
    } = action;
    yield put(IntegrationActions.getIntegrationsLoading(true));
    const integrations = yield IntegrationServices.getIntegrations(orgId);
    yield put(IntegrationActions.getIntegrationsSuccess(integrations));
    if (integrations.success) {
      if (callback) {
        callback(integrations.result);
      }
    }
    yield put(IntegrationActions.getIntegrationsLoading(false));
  } catch (error) {
    yield put(IntegrationActions.getIntegrationsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(integrationActionTypes.GET_INTEGRATIONS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getIntegrations() {
  yield takeLatest(integrationActionTypes.GET_INTEGRATIONS.REQUEST, _getIntegrations);
}

/**
 *
 */
export default function* integrationSaga() {
  yield all([
    getIntegrations(),
  ]);
}
